import { LayoutAnimation, Platform } from 'react-native'

/** Fade-out of the tip on screen when tips are switched off. */
export const TIP_EXIT_FADE_MS = 250

/**
 * After the faded tip unmounts, ease the layout it leaves behind (the map
 * controls bar settling, the map growing back) instead of jumping. Native
 * only: LayoutAnimation is a no-op on web, where the fade already hides it.
 */
export function configureTipExitLayout(): void {
  if (Platform.OS === 'web') return
  LayoutAnimation.configureNext(LayoutAnimation.create(TIP_EXIT_FADE_MS, 'easeInEaseOut', 'opacity'))
}
